import { InputWithIcon } from "@/components/ui/input"
import { Search } from "lucide-react"
import debounce from "lodash-es/debounce"
import { useFilter, useFilterRegistration } from "@/lib/redux-search"

type FullTextFilterConfig = {
  fields: string[]
  type?: string
}

export function FullTextFilter({
  filterId,
  ...filterConfig
}: {
  filterId: string
} & FullTextFilterConfig) {
  useFilterRegistration(filterId, {
    ...filterConfig,
    type: filterConfig.type ?? "full_text",
  })
  const { setValues, values, search } = useFilter(filterId)
  const [query] = values

  return (
    <InputWithIcon
      Icon={Search}
      defaultValue={query}
      onChange={debounce((e) => {
        const query = e.target.value
        if (query.length < 2) {
          setValues([])
        } else {
          setValues([query])
        }
        search()
      }, 300)}
      type="search"
    />
  )
}
